export default __webpack_public_path__ + "static/media/sticker_med_3.be6e2b2d.png";